import { BaseEntity, JsonApiResource } from '../jsonapi-provider';

@JsonApiResource({
  type: 'menu-type-item',
})
export default class MenuTypeItem extends BaseEntity {
  controlInfo: string = '';
  mealType: string = '';
}
